import {
  accountApi,
  applicationApi,
  benefitsApi,
  configApi,
  connectionRequestsApi,
  emailVerifyApi,
  expertApi,
  exportApi,
  levelsApi,
  metaApi,
  taskApi,
  userApi,
  verificationsApi,
} from './endpoints';
import { phoneVerifyApi } from './endpoints/phone-verification';

export const {
  useAccountsQuery,
  useAccountQuery,
  useAzureConsumptionQuery,
  useTeamMembersQuery,
  useInvitationsQuery,
  useLevelupSummaryQuery,
  useAtaRequestsQuery,
} = accountApi;
export const { useApplicationsQuery } = applicationApi;
export const { useAccountBenefitsQuery, useRedeemedBenefitsQuery, useVisualStudioBenefitQuery } = benefitsApi;
export const { useEmailVerificationsQuery } = emailVerifyApi;
export const { usePhoneVerificationsQuery } = phoneVerifyApi;
export const { useLevelUpQuery } = levelsApi;
export const { useMetadataQuery } = metaApi;
export const { useUserQuery } = userApi;
export const { useExportAccountQuery } = exportApi;
export const { useGetTaskQuery } = taskApi;
export const { useConfigQuery } = configApi;
export const { useListBvAppealDocsQuery, useListBvLogsQuery, useListDvAppealDocsQuery, useListDvLogsQuery } =
  verificationsApi;
export const { useExpertQuery, useExpertsQuery, useExpertDetailQuery } = expertApi;
export const { useConnectionRequestsQuery, useConnectionRequestQuery } = connectionRequestsApi;
